export enum LOG_TYPE {
  // 在Server端发起的HTTP请求的日志
  HTTP = 'HTTP',
  // 一次请求到返回只打一次NOTICE日志
  NOTICE = 'NOTICE',
}
export class ServerLogger {
  static log(msg: object, type: LOG_TYPE, isError: boolean = false) {
    if (process.server) {
      console.log(
        `tt=-notice.new tp=server.log${isError ? '.wf' : ''}`,
        JSON.stringify({
          type,
          msg,
        }),
      );
    }
  }

  static logWf(msg: object, type: LOG_TYPE) {
    ServerLogger.log(msg, type, true);
  }
}
